import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { EquipmentList, AttachImplementModalData } from './attach-implement-modal';
@Injectable()
export class AttachImplementModalService {
    constructor(private _http: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public returnEquipmentByJobsite(id: number): Observable<EquipmentList[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('jobsiteId', id.toString());
        return this._http.get("Api/GETEquipment/returnEquipmentByJobsite", {search: params}).share().map(
            (response: Response) => <EquipmentList[]>response.json()).catch(this.handleError);
    }
    public getCompatibleEquipmentForImplementByJobsite(id: number, getAuto: number): Observable<EquipmentList[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('jobsiteId', id.toString());
        params.set('getAuto', getAuto.toString());
        return this._http.get("Api/GETEquipment/getCompatibleEquipmentForImplementByJobsite", { search: params }).share().map(
            (response: Response) => <EquipmentList[]>response.json()).catch(this.handleError);
    }
    public saveAttachImplement(data: AttachImplementModalData): Observable<string> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('implementId', data.implementId.toString());
        params.set('jobsiteId', data.jobsiteId.toString());
        params.set('equipmentId', data.equipmentId.toString());
        params.set('smu', data.smu.toString());
        params.set('cost', data.cost.toString());
        params.set('date', data.date.toDateString());
        params.set('comment', data.comment.toString());
        return this._http.get("Api/Implement/AttachImplementToEquipment", { search: params }).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }
}